/*
  NOURION Liquid Glass: das Glanzlicht auf interaktiven Glasflaechen (.nrn-glas--interaktiv) folgt dem Mauszeiger.
  Nur feine Zeiger mit Hover und ohne reduzierte Bewegung; ein Listener per Delegation, damit auch Sektionen aus dem
  Theme Editor greifen. Die Koordinaten landen als --zeiger-x/--zeiger-y am Element, den Nachlauf macht das CSS
  (registrierte Eigenschaften --glanz-x/--glanz-y mit 700 ms Uebergang, assets/nrn-glas.css).

  Leistung (Messung 15.10.2026): das Rechteck der Flaeche wird einmal beim Betreten gemessen und nur bei Scroll oder
  Groessenaenderung erneut (vorher getBoundingClientRect in jedem Bild, das zwang Stil und Layout je Mausbewegung).
  Geschrieben wird hoechstens einmal je Bild und nur bei geaendertem Wert (Zehntelprozent).

  Zweiter Teil (Leistungsrunde 3, 16.10.2026): Lebendanzeigen .nrn-puls (nrn-glas.css) ruhen ausserhalb des Fensters.
*/
(() => {
  const passt = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let ziel = null;
  let rechteck = null;
  let x = 0;
  let y = 0;
  let rahmen = 0;
  let zx = '';
  let zy = '';

  const messen = () => {
    rechteck = ziel ? ziel.getBoundingClientRect() : null;
  };

  const setzen = () => {
    rahmen = 0;
    if (!ziel || !rechteck || !rechteck.width || !rechteck.height) return;
    const nx = (((x - rechteck.left) / rechteck.width) * 100).toFixed(1) + '%';
    const ny = (((y - rechteck.top) / rechteck.height) * 100).toFixed(1) + '%';
    if (nx !== zx) { zx = nx; ziel.style.setProperty('--zeiger-x', nx); }
    if (ny !== zy) { zy = ny; ziel.style.setProperty('--zeiger-y', ny); }
  };

  document.addEventListener(
    'pointermove',
    (e) => {
      if (!passt.matches || e.pointerType !== 'mouse') return;
      const el = e.target instanceof Element ? e.target.closest('.nrn-glas--interaktiv') : null;
      if (el !== ziel) {
        if (ziel) ziel.removeAttribute('data-glanz-folgt');
        ziel = el;
        zx = '';
        zy = '';
        if (ziel) {
          ziel.setAttribute('data-glanz-folgt', '');
          messen();
        } else {
          rechteck = null;
        }
      }
      if (!ziel) return;
      x = e.clientX;
      y = e.clientY;
      if (!rahmen) rahmen = requestAnimationFrame(setzen);
    },
    { passive: true }
  );

  /* Beim Scrollen (Fenster oder Horizons .page-wrapper) und bei Groessenaenderung wandert die Flaeche unter dem
     Zeiger: Rechteck einmal je Bild neu messen, solange eine Flaeche betreten ist */
  const nachmessen = () => {
    if (!ziel || rahmen) return;
    rahmen = requestAnimationFrame(() => {
      messen();
      setzen();
    });
  };
  document.addEventListener('scroll', nachmessen, { capture: true, passive: true });
  window.addEventListener('resize', nachmessen, { passive: true });
})();

/*
  Lebendanzeigen (.nrn-puls) pulsieren endlos auf dem Compositor. Liegt der Punkt nicht im Fenster, sieht ihn niemand,
  die Schleife hielt den Compositor aber je Bild wach (Messung 16.10.2026: Hero Wege, Ueber uns, Notfall). Ein
  IntersectionObserver setzt data-nrn-ruht, solange der Punkt ausserhalb liegt; nrn-glas.css haelt die Animation dann
  an (animation-play-state). 80 px Vorlauf: rootMargin gilt am Fenster, scrollMargin in verschachtelten Containern
  mit eigenem Scroll (Horizons .page-wrapper). Der Puls laeuft damit meist schon wieder, bevor der Punkt ins Bild
  kommt. Eine Garantie ist das nicht: bei sehr schnellem Scrollen kann ein Punkt kurz stehend sichtbar sein, bis der
  Observer meldet. Browser ohne scrollMargin ignorieren die Option, dort gilt der Vorlauf nur am Fenster. Sektionen
  aus dem Theme Editor (shopify:section:load) werden nachgemeldet; jeder Punkt einmal.
*/
(() => {
  if (!('IntersectionObserver' in window)) return;
  const RUHT = 'data-nrn-ruht';
  const GESEHEN = 'data-nrn-puls-beobachtet';
  const io = new IntersectionObserver(
    (eintraege) => {
      for (const e of eintraege) {
        if (e.isIntersecting) e.target.removeAttribute(RUHT);
        else e.target.setAttribute(RUHT, '');
      }
    },
    { rootMargin: '80px', scrollMargin: '80px' }
  );
  const beobachten = (wurzel) => {
    if (!wurzel || typeof wurzel.querySelectorAll !== 'function') return;
    for (const el of wurzel.querySelectorAll('.nrn-puls:not([' + GESEHEN + '])')) {
      el.setAttribute(GESEHEN, '');
      io.observe(el);
    }
  };
  const start = () => beobachten(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (e) => beobachten(e.target));
})();
